import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { FeatureKey } from '@core/feature-preview/types/feature-key';
import { FeatureService } from '@core/feature-preview/helpers/feature.service';

export const hasFeatureEnabledGuard = (key: FeatureKey): CanActivateFn => {
  return () => {
    const router = inject(Router);
    const featureService = inject(FeatureService);

    const urlTree = router.createUrlTree(['**']);
    const redirect = new RedirectCommand(urlTree);

    return featureService.isFeatureEnabled(key) ? true : redirect;
  };
};
